module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_panqueca.840d0ce0.png";